/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SaveCancelPopup from '../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../SharedModules/Spinner/Spinner';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import {
  getAndDispatchContactDetails,
  setContactTypeDataChangeTried,
  updateAndGetContactTypeDetails,
} from '../store/actions';
import CodeValueTable from './CodeValueTable';
import KeyTypeTable from './KeyTypeTable';
import { isReadOnly as isRead } from '../../../SharedModules/utilities/utilities';

const ContactTypeNew = ({ location }) => {
  const dispatch = useDispatch();
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly;
  if (loginState) {
    isReadOnly = isRead(location.pathname, loginState).readOnly;
  }
  // local State

  const [disableSaveAndCancel, setDisableSaveAndCancel] = useState(false);
  const [actionModal, setActionModal] = useState({ open: false, type: null });
  const [keyTypeFullScreen, setKeyTypeFullScreen] = useState(false);
  const [codeValueFullScreen, setCodeValueFullScreen] = useState(false);

  // Redux State

  const newContactTypeResult = useSelector(
    (state) => state?.sharedState?.ContactTypeReducer?.newContactTypeResult
  );

  const errorMessage = useSelector(
    (state) => state?.sharedState?.ContactTypeReducer?.errorMessage
  );

  const successMessages = useSelector(
    (state) => state?.sharedState?.ContactTypeReducer?.successMessages
  );

  const loading = useSelector(
    (state) => state?.sharedState?.ContactTypeReducer?.loading
  );

  const compareContactTypeResult = useSelector(
    (state) => state?.sharedState?.ContactTypeReducer?.compareContactTypeResult
  );

  const selectedParentKey = useSelector(
    (state) => state?.sharedState?.ContactTypeReducer?.selectedParentKey
  );

  const dataChangeTried = useSelector(
    (state) => state?.sharedState?.ContactTypeReducer?.dataChangeTried
  );

  const childContactTypeError = useSelector(
    (state) => state?.sharedState?.ContactTypeReducer?.childContactTypeError
  );

  // Function

  const openActionModal = (type) => {
    setActionModal({ open: true, type });
  };

  const handleActionModalClose = () => {
    setActionModal({ open: false, type: null });
  };

  const validateBtnDisable = () => {
    if (_.isEqual(newContactTypeResult, compareContactTypeResult)) {
      setDisableSaveAndCancel(true);
    } else {
      setDisableSaveAndCancel(false);
    }
  };

  const handleCancel = () => {
    dispatch(
      getAndDispatchContactDetails(() => {
        handleActionModalClose();
        dispatch(setContactTypeDataChangeTried(Math.random()));
      })
    );
  };

  const handleSave = () => {
    const saveData = _.differenceWith(
      newContactTypeResult,
      compareContactTypeResult,
      _.isEqual
    );

    const apidata = saveData.map((item) => {
      return {
        ...item,
        contactTypeCdVO: item.contactTypeCdVO.map(
          ({ isNewRecord, index, ...rest }) => {
            return { ...rest };
          }
        ),
      };
    });

    dispatch(
      updateAndGetContactTypeDetails(apidata, () => {
        handleActionModalClose();
        dispatch(setContactTypeDataChangeTried(Math.random()));
      })
    );
  };

  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/contactType' && !disableSaveAndCancel) {
          item.isFormDirty = true;
        } else {
          item.isFormDirty = false;
        }
        if (item.navTo === '/contactType' && errorMessage?.length > 0) {
          item.isFormError = true;
        } else {
          item.isFormError = false;
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [errorMessage, disableSaveAndCancel]);

  // close popup on click button
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/contactType' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/contactType' && item.isFormSave) {
          item.isFormSave = false;
          handleSave();
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  useEffect(() => {
    if (
      newContactTypeResult.length === 0 ||
      _.isEqual(newContactTypeResult, compareContactTypeResult)
    ) {
      dispatch(getAndDispatchContactDetails());
    }
    return () => {};
  }, []);

  useEffect(() => {
    validateBtnDisable(newContactTypeResult, compareContactTypeResult);
  }, [dataChangeTried]);

  return (
    <>
      <div className="tabs-container contact-table custom-check">
        {loading && <Spinner load={loading} />}
        <CustomSeparator parent1="System" parent2="Contact Type" />
        {successMessages && (
          <DisplaySuccessMessages successMessages={[successMessages]} />
        )}
        {errorMessage && (
          <DisplayErrorMessages errorMessages={[errorMessage]} />
        )}
        {!keyTypeFullScreen && !codeValueFullScreen && (
          <div className="d-flex justify-content-end align-items-center btn-wrapper mt-3 mb-5">
            <Button
              className="btn btn-success btn-search"
              onClick={() => openActionModal('Save')}
              disabled={
                isReadOnly || disableSaveAndCancel || childContactTypeError
              }
            >
              <SVGComponent iconName="Icon-awesome-save" />
              Save
            </Button>
            <Button
              onClick={() => openActionModal('Cancel')}
              className="btn btn-cancel btn btn-primary"
              disabled={isReadOnly || disableSaveAndCancel}
            >
              <SVGComponent iconName="Icon-cancel" />
              Cancel
            </Button>
          </div>
        )}

        {!codeValueFullScreen && (
          <KeyTypeTable
            contactTypeSearchResult={newContactTypeResult}
            selectedParentKey={selectedParentKey}
            childContactTypeError={childContactTypeError}
            fullScreen={keyTypeFullScreen}
            setFullScreen={setKeyTypeFullScreen}
            isReadOnly={isReadOnly}
          />
        )}
        {!keyTypeFullScreen && (
          <CodeValueTable
            selectedParentKey={selectedParentKey}
            fullScreen={codeValueFullScreen}
            setFullScreen={setCodeValueFullScreen}
            isReadOnly={isReadOnly}
          />
        )}

        <SaveCancelPopup
          open={actionModal.open}
          title={actionModal.type}
          onConfim={() => {
            if (actionModal.type === 'Save') {
              handleSave();
            } else {
              handleCancel();
            }
          }}
          onCancel={handleActionModalClose}
          moduleName=""
        />
      </div>
    </>
  );
};

export default ContactTypeNew;
